export var COIN_RIVE_ANIMATION = 'final_coin';